import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import cntnctimg3 from "../../Images/cntnctimg3.png";
import cmtprofiletwoimg from "../../Images/cmtprofiletwoimg.png"
import { commentAdd } from '../../Redux/Slice/PostSlice';
import { formatDateAgo } from '../../utils/Helper';
import { LoadBusinessPostsInBackground, fetchMyBusinessPosts } from '../../Redux/Slice/BusinessPostSlice';
import toast from 'react-hot-toast';
import TextareaAutosize from 'react-textarea-autosize';
import PostCommentsEdit from "../SearchHome/PostCommentsEdit";
import { Link } from 'react-router-dom';

const PostCommentsNew = ({ data, postProfileId, postId, onPostUpdate = () => { } }) => {
    const dispatch = useDispatch()
    const { UserProfileID } = useSelector((state) => state.app);
    const [allComments, setAllComments] = useState([])
    const [commentToEdit, setCommentToEdit] = useState("")
    const { AllBusinessPosts } = useSelector((state) => state.post);
    const [commentText, setCommentText] = useState("")

    useEffect(() => {
        setAllComments(data?.slice().sort((a, b) => new Date(b?.createdOn) - new Date(a?.createdOn)))
    }, [data])

    const handleCommentSend = (e) => {
        e.preventDefault()
        if (commentText.trim() === "") {
            return toast.error("Your comment should not be empty!")
        }
        const data = {
            postId: postId,
            comment: commentText
        }

        dispatch(commentAdd(data))
        dispatch(LoadBusinessPostsInBackground())
        // dispatch(fetchMyBusinessPosts())
        setCommentText("")
        onPostUpdate();
    }

    const handleCommentUpdated = () => {
        dispatch(LoadBusinessPostsInBackground())
        // dispatch(fetchMyBusinessPosts())
        onPostUpdate();
    }

    useEffect(() => {
        setAllComments(AllBusinessPosts.find(post => post._id === postId)?.PostCommentData.slice().sort((a, b) => new Date(b?.createdOn) - new Date(a?.createdOn)) || []);
    }, [AllBusinessPosts])

    return (
        <>
            <div className='ownpostcommentdiv'>
                <div className='ownpostcommentdivmain'>
                    <div className="cntnctimgdivnamin">
                        <img src={UserProfileID?.profilePhoto || cntnctimg3} alt={UserProfileID?.personName || "..."} />
                    </div>

                    <div style={{
                        height: 'auto'
                    }} className='textareadibmainmainbrdr'>
                        <div className='textareadibmain'>
                            <TextareaAutosize style={{
                                width: '100%',
                                resize: 'none',
                                border: 'none',
                                padding: '10px',
                                outline: 'none',
                                paddingRight: '60px'
                            }} value={commentText || ""} onChange={(e) => setCommentText(e.target.value)} placeholder='Write a comment...' />
                        </div>
                        {
                            commentText?.trim() && (
                                <>
                                    <div className="mesagsendidvmain"
                                        style={{
                                            marginTop: "-35px",
                                        }}
                                        onClick={(e) => handleCommentSend(e)}>
                                        <i className="fa-solid fa-paper-plane" style={{ cursor: "pointer" }}></i>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
                {/* // } */}

                {
                    allComments?.length > 0 && allComments.map((comment, index) => {
                        return (
                            <>
                                <div className='ownpostothercommentdivmain'>
                                    <div className='profikellcmnjhhrrddivflxttst'>
                                        <div className='profikellcmntimgdivflxttst'>
                                            <div className='commentproofilleimg cntnctimgdivnamin'>
                                                <Link
                                                    to={comment?.commentedBy[0]?.userName ? `/profile/${comment?.commentedBy[0]?.userName}` : `#`}
                                                    className="cntnctimgdivnamin">
                                                    <img src={comment?.commentedBy[0]?.profilePhoto || cmtprofiletwoimg} alt='Profile Image' />
                                                </Link>
                                            </div>
                                            <p className='commporosttxttnamepp'>{comment?.commentedBy[0]?.personName}</p>
                                        </div>
                                        <p className='commporosttxttnamepp'>{formatDateAgo(comment?.createdOn)}</p>
                                    </div>

                                    <div className='commsoprpodttctxppp'>
                                        {UserProfileID?._id == comment?.commentedBy[0]?._id ? (
                                            <PostCommentsEdit comment={comment} postId={postId} onUpdate={handleCommentUpdated} />
                                        ) : (<p> {comment?.comment}</p>)}
                                    </div>
                                </div>
                            </>
                        )
                    })
                }
            </div>
        </>
    )
}

export default PostCommentsNew
